import axios from 'axios'
import { BASE_URL } from '../../constants/config'

async function listReservationSummary(token, timestamp) {
    const options = {
        method: 'get',
        headers: {
            'Authorization': `JWT ${token}`
        },
        params: {
            timestamp
        },
        url: `${BASE_URL}/admin/reservation/summary`
    }
    return axios(options)
}

async function listReservations(token, limit, skip, productId,time) {
    const options = {
        method: 'get',
        headers: {
            'Authorization': `JWT ${token}`
        },
        params: {
            time,
            productId,
            limit,
            skip
        },
        url: `${BASE_URL}/admin/reservation`
    }
    return axios(options)
}

export default {
    listReservationSummary,
    listReservations
}